import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {DamCatalogService} from '../../../cabinet/dam/services/dam-catalog.service';
import {ChooseCatalogModalComponent} from '../../choose-catalog-modal/choose-catalog-modal.component';

@Component({
  selector: 'app-choose-dam-catalog-modal',
  templateUrl: './../../choose-catalog-modal/choose-catalog-modal.component.html',
  styleUrls: ['./../../choose-catalog-modal/choose-catalog-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamChooseCatalogModalComponent extends ChooseCatalogModalComponent {

  constructor(protected readonly catalogService: DamCatalogService,
              protected readonly windowRef: NbWindowRef) {
    super(catalogService, windowRef);
  }
}
